"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleButton = exports.LogoWrapper = exports.HeaderContainer = exports.ContentContainer = exports.DrawerContainer = exports.DrawerWrapper = void 0;

const styled_components_1 = __importStar(require("styled-components"));

const inventory_1 = require("../../theme/inventory");

const DRAWER_WIDTH_OPEN = '240px';
const DRAWER_WIDTH_COLLAPSED = '46px';
exports.DrawerWrapper = styled_components_1.default.div`
  box-sizing: border-box;
  flex: 0 0 auto;
  width: ${DRAWER_WIDTH_OPEN};
  transition: margin 0.5s;

  * {
    box-sizing: border-box;
  }

  ${props => props.isCollapsed && (0, styled_components_1.css)`
      margin-left: calc(${DRAWER_WIDTH_COLLAPSED} - ${DRAWER_WIDTH_OPEN});
    `}
`;
exports.DrawerContainer = styled_components_1.default.div`
  overflow: hidden;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: ${DRAWER_WIDTH_OPEN};
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  padding: 22px 24px;
  background-color: ${props => props.theme.colors[inventory_1.GeneralColorNames.white]};

  z-index: 2;
  transition: width 0.5s, padding 0.5s;
  ${props => props.isCollapsed && (0, styled_components_1.css)`
      width: ${DRAWER_WIDTH_COLLAPSED};
      padding: 22px 10px;
    `}
`;
const BaseContainer = styled_components_1.default.div`
  min-width: 192px;
  transition: opacity 0.5s, transform 0.5s;
  ${props => props.isCollapsed && (0, styled_components_1.css)`
      transform: translateX(-100%);
      opacity: 0;
    `}
  ${props => props.isHidden && (0, styled_components_1.css)`
      visibility: hidden;
    `}
`;
exports.ContentContainer = (0, styled_components_1.default)(BaseContainer)`
  overflow-y: auto;
  min-height: 300px;
  max-height: calc(100vh - 62px);
  ${props => props.overflowY && (0, styled_components_1.css)`
      margin-right: -15px;
    `}
`;
exports.HeaderContainer = (0, styled_components_1.default)(BaseContainer)`
  margin-bottom: 20px;
`;
exports.LogoWrapper = styled_components_1.default.a.attrs({})`
  display: flex;
`;
exports.ToggleButton = styled_components_1.default.button.attrs({
  type: 'button'
})`
  height: 24px;
  width: 24px;
  border: 0;
  outline: 0;
  background: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${props => props.theme.colors[inventory_1.GeneralColorNames.gray_602]};
  position: absolute;
  cursor: pointer;
  transition: color 0.2s;
  right: 18px;
  top: 17px;

  ${props => props.isDisabled ? (0, styled_components_1.css)`
          cursor: default;
        ` : (0, styled_components_1.css)`
          &:hover,
          &:focus {
            color: ${props.theme.colors[inventory_1.GeneralColorNames.primary_700_main]};
          }
        `}

  ${props => props.isCollapsed && (0, styled_components_1.css)`
      right: 11px;

      svg {
        transform: scale(-1, 1);
      }
    `};
`;